var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-0"},_vm._l((_vm.medicalProcedures),function(item,index){return _c('v-row',{key:index,attrs:{"no-gutters":""}},[_c('v-col',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('span',{staticClass:"text-caption"},[_vm._v(_vm._s(item.productName))])])],1)],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }